import { Component, Input } from '@angular/core';

@Component({
    selector: 'app-file-company',
    templateUrl: './file-company.component.html',
    standalone: false
})
export class FileCompanyComponent {

  @Input() his?: string;
}
